
/* injects from baggage-loader */

import greenStone from '../../../assets/images/tela-montanha/pedra_mult.png';
import blueStone from '../../../assets/images/tela-montanha/pedra_mais.png';
import yellowStone from '../../../assets/images/tela-montanha/pedra_menos.png';
import redStone from '../../../assets/images/tela-montanha/pedra_dividir.png';

export const stoneList = [
	greenStone, 
	blueStone,
	yellowStone,
	redStone
];


// WEBPACK FOOTER //
// ./src/app/pages/montanha/montanha.const.js